import { LayoutGrid, Table as TableIcon } from 'lucide-react'

/**
 * Reusable view switcher
 * - ใช้ได้ 2 แบบเพื่อความยืดหยุ่น:
 *   1) <ViewSwitcher view={value} setView={setValue} />
 *   2) <ViewSwitcher value={value} onChange={setValue} />
 */
export default function ViewSwitcher({
  view,
  setView,
  value,
  onChange,
  labels = { card: 'การ์ด', table: 'ตาราง' },
  size = 'md',
  className = ''
}) {
  const current = view ?? value ?? 'card'
  const change = setView ?? onChange ?? (() => {})

  const btnSize = size === 'sm' ? 'px-2.5 py-1.5 text-xs' : 'px-3 py-2 text-sm'

  return (
    <div className={`inline-flex rounded-lg overflow-hidden border border-gray-200 ${className}`}>
      <button
        onClick={() => change('card')}
        className={[
          btnSize,
          'inline-flex items-center gap-1 whitespace-nowrap',
          current === 'card' ? 'bg-primary text-white' : 'bg-white text-gray-700 hover:bg-gray-50'
        ].join(' ')}
        title="มุมมองการ์ด"
      >
        <LayoutGrid size={size === 'sm' ? 14 : 16} /> {labels.card}
      </button>
      <button
        onClick={() => change('table')}
        className={[
          btnSize,
          'inline-flex items-center gap-1 whitespace-nowrap',
          current === 'table' ? 'bg-primary text-white' : 'bg-white text-gray-700 hover:bg-gray-50'
        ].join(' ')}
        title="มุมมองตาราง"
      >
        <TableIcon size={size === 'sm' ? 14 : 16} /> {labels.table}
      </button>
    </div>
  )
}
